import { Component, Input, SimpleChanges } from '@angular/core';
import { max, round } from 'lodash';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { IIecBallotVote } from '../../../shared/models/iec/iec-ballot-vote';

@Component({
    selector: 'app-iec-consensus-criteria',
    templateUrl: './iec-consensus-criteria.component.html',
    styleUrl: './iec-consensus-criteria.component.scss',
    standalone: false
})
export class IecConsensusCriteriaComponent {
  @Input() ballotVotes: IIecBallotVote[] = [];
  @Input() data: IDonutChartItem[] = [];
  @Input() isRefresh: boolean = false;
  isShowingHelp: boolean = false;
  hasMetConsensus: boolean = false;


  ngOnInit() {
    this.calculatePercentages();
  }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['data'] && !changes['data'].firstChange && this.isRefresh) {
          console.log(`this section has been refreshed`);
          this.calculatePercentages();
      }
    }
  openModal() {
    this.isShowingHelp = true;
  }

  closeModal() {
    this.isShowingHelp = false;
  }

  calculatePercentages() {
    const total = this.data.reduce((sum, item) => sum + (item.value ?? 0), 0);
    // Calculate percentage and round
    let percentages = this.data.map(item => ({
      ...item,
      percentage: total ? Math.round((item.value / total) * 100) : 0
    }));

    // Adjust rounding errors to ensure the total is exactly 100%
    let diff = 100 - percentages.reduce((sum, item) => sum + item.percentage, 0);
    if (diff !== 0) {
      let indexToAdjust = percentages.findIndex(item => item.percentage > 0);
      if (indexToAdjust !== -1) {
        percentages[indexToAdjust].percentage += diff;
      }
    }

    this.data = percentages;
    this.checkConsensus();
  }

  checkConsensus(){
    if(this.data && this.data.length > 0){
      const filteredData = this.data.filter(item => item.label !== 'No Response');
      const maxPercentage = Math.max(...filteredData.map(item => item.percentage || 0));
      const roundedPercentage = Math.round(maxPercentage);
      if(roundedPercentage >= 67){
        this.hasMetConsensus = true;
      }
    }
  }
}
